module.exports = __webpack_public_path__ + "assets/images/notificationsHelp/chrome-f07d998383d3f5be933c94836364df96.png";